import React from "react";
import { useNavigate } from "react-router-dom";

const SubscriptionCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Cancel icon */}
        <div className="mb-8">
          <div className="w-24 h-24 mx-auto bg-gray-700 rounded-full flex items-center justify-center">
            <svg
              className="w-12 h-12 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
        </div>

        {/* Message */}
        <h1 className="text-3xl font-bold text-white mb-4">
          Payment Cancelled
        </h1>

        <p className="text-gray-400 mb-8">
          Your payment was cancelled. No charges were made to your account.
          You can try again anytime or continue using the free plan.
        </p>

        {/* Help section */}
        <div className="bg-[#1a1a1a] rounded-2xl p-6 mb-8 text-left">
          <h3 className="text-white font-semibold mb-4">Need help?</h3>
          <ul className="space-y-3 text-gray-400 text-sm">
            <li className="flex items-start gap-3">
              <span className="text-gray-500">•</span>
              If you experienced any issues during checkout, please try again
              or contact our support team.
            </li>
            <li className="flex items-start gap-3">
              <span className="text-gray-500">•</span>
              You can still use all free features while deciding on a plan.
            </li>
            <li className="flex items-start gap-3">
              <span className="text-gray-500">•</span>
              Our plans come with a satisfaction guarantee - cancel anytime.
            </li>
          </ul>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate("/pricing")}
            className="px-6 py-3 bg-[#3af062] text-black font-semibold rounded-xl hover:bg-[#2dd54f] transition-colors"
          >
            Try Again
          </button>
          <button
            onClick={() => navigate("/")}
            className="px-6 py-3 bg-gray-700 text-white font-semibold rounded-xl hover:bg-gray-600 transition-colors"
          >
            Continue with Free
          </button>
        </div>

        {/* Contact support */}
        <p className="mt-8 text-gray-600 text-sm">
          Questions?{" "}
          <a href="mailto:support@mixxai.com" className="text-[#3af062] hover:underline">
            Contact Support
          </a>
        </p>
      </div>
    </div>
  );
};

export default SubscriptionCancel;
